import {
    axiosGet,
  } from "../../../../../app/Helpers/AxiosHelper";
  
  import {
    ABLYINIT, UNAUTHABLYINIT
  } from "../../../../../app/Config/ApiUrl";
  
  import Ably from 'ably';
  
  /**
   * Fetches Ably tokens from the backend.
   * @param {boolean} isAuth - Determines whether to use authenticated or unauthenticated API.
   * @returns {Promise<string>} - The fetched Ably token.
   */

  
  async function fetchTokens(isAuth = true) {
    try {
      const response = await axiosGet(isAuth ? ABLYINIT : UNAUTHABLYINIT);
      if (!response || !response.data || !response.data.ably_token) {
        throw new Error("Invalid Ably token response from server");
      }
      return response.data.ably_token;
    } catch (error) {
      console.error("Failed to fetch Ably token:", error);
      throw error;
    }
  }
  
  /**
   * Initializes the Ably Realtime client.
   * Handles token expiration and reconnections.
   * @param {boolean} isAuth - Determines whether to use authenticated or unauthenticated token.
   * @returns {Promise<object>} - Returns an initialized Ably client.
   */
  async function initializeAblyClient(isAuth = true) {
    try {
      const ably = new Ably.Realtime({
        authCallback: async (tokenParams, callback) => {
          try {
            const token = await fetchTokens(isAuth);
            callback(null, token);
          } catch (error) {
            callback(error, null);
          }
        },
      });
  
      // Connection state change handling
      ably.connection.on("stateChange", (stateChange) => {
        console.log("Connection state changed to:", stateChange.current);
        if (stateChange.current === "disconnected" || stateChange.current === "suspended") {
          console.warn("Ably disconnected. Attempting to reconnect...");
        } else if (stateChange.current === "connected") {
          console.log("Successfully connected to Ably.");
        }
      });
  
      return { ably };
    } catch (error) {
      console.error("Failed to initialize Ably client:", error);
      throw error;
    }
  }
  
  export { initializeAblyClient, fetchTokens };
  